import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "1. What we collect",
    body: "When you request access, we collect your name, agency, work email, city or market, and any optional details you choose to share about your deal volume or mandates. Inside the app, members' posts contain property specifications and search criteria — never client names or full addresses unless both parties agree to disclosure.",
  },
  {
    title: "2. How we use it",
    body: "We use your details to review membership applications, operate the matching service, and communicate with you about your account. We do not sell personal data, run advertising, or share your information with third parties beyond the processors required to operate the service.",
  },
  {
    title: "3. A sealed network",
    body: "Content posted to PrimeConnect is visible only to verified member agents. Nothing in the network is public, indexed, or accessible to search engines.",
  },
  {
    title: "4. Retention & your rights",
    body: "Application data is retained while your membership is considered or active. You may request access, correction, or deletion of your personal data at any time by writing to hello@primeconnect.network.",
  },
  {
    title: "5. Security",
    body: "Access is authenticated per member, connections are encrypted in transit, and disclosure of addresses and client identities is gated behind mutual acceptance and recorded confidentiality terms.",
  },
  {
    title: "6. Contact",
    body: "Data controller: PrimeConnect Ltd, London. Privacy questions and requests: hello@primeconnect.network.",
  },
];

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#FAF9F5] text-[#141518] py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-6 sm:px-8">
        <Reveal>
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-2 text-sm text-[#635F57] hover:text-[#141518] transition-colors duration-300"
          >
            <ArrowLeft size={15} /> Back to PrimeConnect
          </Link>
          <p className="font-eyebrow text-[11px] text-[#928E84] mt-12">Legal</p>
          <h1 className="font-display font-medium tracking-tight text-4xl sm:text-5xl mt-4">
            Privacy Policy
          </h1>
          <p className="text-sm text-[#928E84] mt-4">Last updated: July 2026</p>
        </Reveal>
        <div className="mt-14 space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <h2 className="font-display text-2xl">{s.title}</h2>
              <p className="text-base text-[#635F57] leading-relaxed mt-4">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
